module.exports = __webpack_public_path__ + "assets/img/returnBtn-90172114.png";